export default __webpack_public_path__ + "static/media/sn.02a1b009.jpg";